<form [formGroup]="fG">
  <ejs-timepicker [placeholder]="placeholder" [formControlName]="fCN" [cssClass]="cssClass + ' ' + (fG.controls[fCN].invalid && fG.controls[fCN].dirty ? 'e-error' : '')" [step]="step"></ejs-timepicker>
</form>
